import React from "react";

import '../../../../panel/new_weight/new_weight.scss';

import './htmlContent.scss';


const  HtmlContent= ({content, style}) => {

    return (
     <div className={`html-content ${style??''}` } dangerouslySetInnerHTML={{ __html: content }} />
    );



}

export default HtmlContent;